(() => {
  if (window.AboutGuiVariantCards) {
    window.AboutGuiVariantCards.scan?.();
    return;
  }

  const cache = new Map();
  const observed = new WeakSet();

  const productJsonUrl = (href) => {
    const url = new URL(href, window.location.origin);
    url.search = '';
    url.hash = '';
    url.pathname = `${url.pathname.replace(/\/$/, '')}.js`;
    return url.toString();
  };

  const getProduct = (href) => {
    const url = productJsonUrl(href);
    if (!cache.has(url)) {
      cache.set(
        url,
        fetch(url, { credentials: 'same-origin' })
          .then((response) => {
            if (!response.ok) throw new Error(`Product request failed: ${response.status}`);
            return response.json();
          })
          .catch((error) => {
            cache.delete(url);
            throw error;
          })
      );
    }
    return cache.get(url);
  };

  const findColorIndex = (product) => {
    const options = Array.isArray(product.options) ? product.options : [];
    return options.findIndex((option) => {
      const name = typeof option === 'string' ? option : option?.name;
      return ['color', 'colour'].includes(String(name || '').toLowerCase());
    });
  };

  const imageForVariant = (variant) => {
    const image = variant?.featured_image;
    if (!image) return null;
    if (typeof image === 'string') return image;
    return image.src || image.url || null;
  };

  const enhanceCard = async (card) => {
    if (card.dataset.aboutGuiVariantsLoaded === 'true') return;
    card.dataset.aboutGuiVariantsLoaded = 'true';

    const link = card.querySelector('a[href*="/products/"]');
    const info = card.querySelector('.card-information') || card.querySelector('.card__information');
    if (!link || !info) return;

    try {
      const product = await getProduct(link.href);
      const colorIndex = findColorIndex(product);
      if (colorIndex < 0) return;

      const optionKey = `option${colorIndex + 1}`;
      const colors = new Map();

      (product.variants || []).forEach((variant) => {
        const color = variant?.[optionKey];
        const image = imageForVariant(variant);
        if (!color || !image) return;

        const existing = colors.get(color);
        if (!existing || (!existing.available && variant.available)) {
          colors.set(color, {
            id: variant.id,
            color,
            image,
            available: Boolean(variant.available)
          });
        }
      });

      if (colors.size < 2) return;

      const wrapper = document.createElement('div');
      wrapper.className = 'about-gui-variant-swatches';
      wrapper.setAttribute('aria-label', 'Available color images');

      [...colors.values()].forEach((item, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = `about-gui-variant-swatch${item.available ? '' : ' is-unavailable'}${index === 0 ? ' is-active' : ''}`;
        button.style.setProperty('--ag-swatch-image', `url("${item.image.replace(/"/g, '%22')}")`);
        button.title = item.color;
        button.setAttribute('aria-label', `View ${item.color}`);
        button.dataset.variantId = item.id;
        button.dataset.image = item.image;

        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          const image = card.querySelector('.card__media .media img:first-child');
          if (image) {
            image.src = item.image;
            image.srcset = item.image;
          }

          card.classList.add('about-gui-variant-selected');
          wrapper.querySelectorAll('.about-gui-variant-swatch').forEach((swatch) => swatch.classList.remove('is-active'));
          button.classList.add('is-active');

          card.querySelectorAll('a[href*="/products/"]').forEach((productLink) => {
            const url = new URL(productLink.href, window.location.origin);
            url.searchParams.set('variant', item.id);
            productLink.href = `${url.pathname}${url.search}`;
          });
        });

        wrapper.appendChild(button);
      });

      info.appendChild(wrapper);
    } catch (error) {
      console.debug('About-Gui variant cards:', error);
    }
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        enhanceCard(entry.target);
      });
    },
    { rootMargin: '500px 0px' }
  );

  const scan = (root = document) => {
    root.querySelectorAll('.product-card-wrapper').forEach((card) => {
      if (observed.has(card)) return;
      observed.add(card);
      observer.observe(card);
    });
  };

  const mutationObserver = new MutationObserver(() => scan());
  mutationObserver.observe(document.documentElement, { childList: true, subtree: true });

  window.AboutGuiVariantCards = { scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan());
  else scan();
})();